import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger)

// export default (function () {
//   let object = {
//     el: '.bubble',
//     duration: 6
//   }

//   function init() {

//     gsap.fromTo(object.el, object.duration, {
//       opacity: 1,
//       y: "0",
//       x: Math.PI * 4,
//       scale: 1,
//       repeatRefresh: true,
//       transformOrigin: 'center'
//     }, {
//       opacity: 0,
//       y: '100',
//       x: Math.PI * 4,

//       scale: 0,

//       stagger: {
//         each: object.duration / document.querySelectorAll(object.el).length,
//         repeat: -1,

//       }
//     });
//   }
//   return {
//     init: init,
//   }


//   /* eslint-enable no-unused-vars */

// })()



export function runBubbles(group) {

  let scrollTrigger = {};

    scrollTrigger = {
      trigger: group,
      start: 'top+=20% bottom',
      end: 'bottom bottom'
    };


  gsap.fromTo(group,
  { opacity: 0, bottom:"0", left: "random(0,2000)" },
  {
    scrollTrigger: scrollTrigger,
    stagger: {
      amount: .20,
      from: "random"
    },
    opacity: 1,
    bottom: "80%",
    duration: "random(1, 7)",
    ease: "power3.inOut",
    repeat: -1,
    repeatRefresh: true
  })
}

export default function() {
  const groups = [...document.querySelectorAll('[data-bubble]')]
  groups.forEach((group) => {
    runBubbles(group)
  })
}

